import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Rating from "@material-ui/lab/Rating";
import UpdateIcon from "@material-ui/icons/Update";

const SkillItem = (props) => {
  const [skill, setSkill] = useState({ _id: null, name: "", stars: null });
  const updateSkill = props.updateSkill;
  const authContext = useContext(AuthContext);
  const history = useHistory();
  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setSkill({
      _id: props.skill._id,
      name: props.skill.name,
      stars: parseInt(props.skill.stars),
    });
  }, [props.editing]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #e1e1e1",
        padding: "5px 5px 5px 0px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <p
          style={{
            margin: "0",
            marginRight: "10px",
            padding: "15px 0%",
          }}
        >
          {skill.name}
        </p>
        {!props.editing && <Rating value={skill.stars} readOnly />}
      </div>
      {props.editing && (
        <>
          <Rating
            value={skill.stars}
            onChange={(e) => {
              setSkill({ ...skill, stars: e.target.value });
            }}
            style={{ marginTop: "5px" }}
          />
          <IconButton
            variant="outlined"
            color="primary"
            style={{ justifySelf: "flex-end" }}
            onClick={(e) => updateSkill(e, skill)}
          >
            <UpdateIcon />
          </IconButton>
          <IconButton
            variant="outlined"
            color="secondary"
            style={{ justifySelf: "flex-end" }}
            onClick={() => props.removeSkill(props.skill)}
          >
            <DeleteIcon />
          </IconButton>
        </>
      )}
    </div>
  );
};

export default SkillItem;
